import React from 'react';
import { Link } from 'react-router-dom';
import { buttonClasses } from '../utils/buttonStyles';
export function NotFound() {
  return <div className="mx-auto max-w-site px-5 py-20 md:px-8 md:py-24" data-id="element-1247" data-mp="w4t0kp2c0ng5">
      <h1 className="font-display text-6xl font-semibold uppercase" data-id="element-1248" data-mp="105la7jf48ucy">Page not found</h1>
      <p className="mt-4 text-titanium" data-id="element-1249" data-mp="155h7z0x7zpk2">The page you're looking for doesn't exist.</p>
      <Link to="/" className={`${buttonClasses('primary')} mt-8`} data-id="element-1250" data-mp="1a4ajinsy56hl">Return home</Link>
    </div>;
}